import React from "react";
import { useSelector } from "react-redux";
import MovieList from "../../Components/MovieList/movielist";

const FavouriteMovies = () => {
  const favouriteMovies = useSelector(
    (state) => state.movies?.favouriteMovies || []
  );
  return favouriteMovies.length === 0 ? (
    <p className="text-white text-5xl font-semibold mt-10 text-center">
      Please add some movies in it. Currently, you dont have any favourite movie
    </p>
  ) : (
    <MovieList movies={favouriteMovies} category={"Favourite"} />
  );
};

export default FavouriteMovies;
